const sessionStorageRootKey = "@Smls:register";

export default {
  key: `${sessionStorageRootKey}:user`,
  routes: `${sessionStorageRootKey}:routes`,
};
